export default "__VITE_ASSET__CBJI1JLO__"